module.exports = __webpack_public_path__ + "static/media/checkbox.01663232.svg";